module.exports = __webpack_public_path__ + "img/product_slider_title.4b80481.png";